module.exports = __webpack_public_path__ + "img/icon-car-8.eb952a62.png";